import { useEffect, useState } from "react";
import { Megaphone, Loader2 } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { LeadForm } from "@/components/common/LeadForm";
import { api } from "@/lib/api";

const ESTADO_TONE = {
  nuevo: "bg-sky-100 text-sky-700",
  en_proceso: "bg-amber-100 text-amber-700",
  convertido: "bg-emerald-100 text-emerald-700",
  descartado: "bg-slate-200 text-slate-600",
};

export default function Prospeccion() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const cargar = async () => {
    try {
      const { data } = await api.get("/leads");
      setLeads(data.leads || []);
    } catch (e) { console.debug("cargar leads (prospección):", e?.response?.status); } finally { setLoading(false); }
  };
  useEffect(() => { cargar(); }, []);

  return (
    <div data-testid="prospeccion-page">
      <PageHeader title="Prospección" subtitle="Captura de prospectos en campo · datos mínimos" />
      <div className="grid gap-6 p-6 md:p-8 lg:grid-cols-2">
        {/* Captura */}
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="mb-4 flex items-center gap-2">
            <Megaphone className="h-5 w-5 text-primary" />
            <h2 className="font-heading text-base font-semibold text-slate-800">Nuevo lead</h2>
          </div>
          <LeadForm onSaved={cargar} />
        </div>

        {/* Mis leads */}
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <h2 className="mb-4 font-heading text-base font-semibold text-slate-800">Mis leads ({leads.length})</h2>
          {loading ? (
            <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
          ) : leads.length === 0 ? (
            <p className="py-8 text-center text-sm text-slate-400">Aún no has capturado leads.</p>
          ) : (
            <ul className="max-h-[460px] space-y-2 overflow-y-auto">
              {leads.map((l) => (
                <li key={l.id} data-testid={`mi-lead-${l.id}`} className="rounded-md border border-slate-100 p-3 text-sm">
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-slate-700">{l.nombre}</span>
                    <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${ESTADO_TONE[l.estado] || "bg-slate-100"}`}>{l.estado}</span>
                  </div>
                  <p className="text-xs text-slate-500">{l.direccion || "Sin dirección"}</p>
                  {l.monto_solicitado != null && <p className="text-xs text-slate-500">Monto: ${Number(l.monto_solicitado).toLocaleString("es-MX")}{l.tasa_ofrecida ? ` · ${l.tasa_ofrecida}%` : ""}</p>}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
